import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import { reduxForm, formValueSelector, change } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import getDefaultValues from "../components/form/getDefaultValues";
import { FormField, Responsive, Toolbar } from "admin-on-rest";
import { ValuesForm, SearchChips } from "../components";

class CollectionsForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      if (values.marketer_id === null) {
        values.marketer_id = 0;
      }
      this.props.save(values, redirect);
    });
  constructor(props) {
    super(props);

    this.state = {
      products: [],
      nameProducts: [],
      isLoadProducts: true
    };
  }
  componentWillReceiveProps(nextProps) {
    const { products } = nextProps;
    if (products && products.length > 0 && this.state.isLoadProducts) {
      //console.log(products);
      let content = [];
      products.map((item, index) => {
        return content.push(item.id);
      });
      // console.log(products);
      this.setState({
        products,
        nameProducts: content,
        isLoadProducts: false
      });
    }
  }

  onChangeProducts = products => {
    this.props.updateProduct(products);
  };
  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar
    } = this.props;
    const { nameProducts, products } = this.state;
    return (
      <div>
        <form className="simple-form">
          <Responsive
            small={
              <div style={{ padding: "3em 1em 6em 1em" }}>
                {Children.map(
                  children,
                  input =>
                    input && (
                      <div
                        key={input.props.source}
                        className={`aor-input-${input.props.source}`}
                        style={input.props.style}
                      >
                        <FormField
                          input={input}
                          resource={resource}
                          record={record}
                          basePath={basePath}
                        />
                      </div>
                    )
                )}
              </div>
            }
            medium={
              <div style={{ padding: "0 1em 1em 1em" }}>
                {Children.map(
                  children,
                  input =>
                    input && (
                      <div
                        key={input.props.source}
                        className={`aor-input-${input.props.source}`}
                        style={input.props.style}
                      >
                        <FormField
                          input={input}
                          resource={resource}
                          record={record}
                          basePath={basePath}
                        />
                      </div>
                    )
                )}
              </div>
            }
          />
          <SearchChips
            data={products}
            nameProducts={nameProducts}
            onChangeProduct={this.onChangeProducts.bind(this)}
          />
          <ValuesForm isDebug={false} formName={"record-form"} />
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
      </div>
    );
  }
}

CollectionsForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func
};

CollectionsForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};
const selector = formValueSelector("record-form");
const enhance = compose(
  connect(
    (state, props) => {
      const products = selector(state, "products");
      return {
        initialValues: getDefaultValues(state, props),
        products
      };
    },
    {
      updateProduct: products => change("record-form", "products", products)
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

export default enhance(CollectionsForm);



// WEBPACK FOOTER //
// ./src/collections/CollectionsForm.js